import React, { Ref, useState } from 'react';
import classNames from 'classnames';
import OverlaySpinner from 'Components/OverlaySpinner';
import { UISpinnerProps } from 'Components/UIComponents/UISpinner';
import { Requisite } from 'Interfaces/Requisite';

interface RequisiteItemProps {
  requisiteItem: Requisite;
  className?: string;
  spinnerProps?: UISpinnerProps;
  imgRef?: Ref<HTMLImageElement>;
}

const RequisiteItem = ({
  className,
  requisiteItem,
  spinnerProps,
  imgRef,
}: RequisiteItemProps) => {
  const [isLoadingImg, setIsLoadingImg] = useState(true);

  return (
    <div
      className={classNames('settingsSignature__item-inner', {
        'settingsSignature__item--loading': isLoadingImg,
      })}
    >
      {isLoadingImg && <OverlaySpinner spinnerProps={spinnerProps} />}
      <img
        ref={imgRef}
        src={requisiteItem.url}
        onLoad={() => setIsLoadingImg(false)}
        className={classNames('settingsSignature__item-img', className)}
        alt="signature"
      />
    </div>
  );
};

export default RequisiteItem;
